<style>
.input-readonly > div > .vs-inputx {
  background-color: #e6e6e6;
}
.bg-dark {
  background-color: #e6e6e6 !important;
}
</style>
<template>
  <div class="w-full ml-auto mr-auto">
    <vs-divider style="width: 100%"><b>Debit Note Apply Schema</b></vs-divider>
    <vs-table v-if="schemaLines.length > 0" :data="schemaLines">
      <template slot="thead">
        <vs-th> # </vs-th>
        <!-- <vs-th> Applied To </vs-th>
        <vs-th> Code </vs-th>
        <vs-th> Remaining Before </vs-th>
        <vs-th> Debit Note Code </vs-th>
        <vs-th> Debit Note Remaining Before </vs-th>
        <vs-th> Paid </vs-th>
        <vs-th> Remaining After </vs-th>
        <vs-th> Debit Note Remaining After </vs-th> -->
        <vs-th>Debit Note Code</vs-th>
        <vs-th>Total DN Used on Schema</vs-th>
        <vs-th>Invoice Number</vs-th>
        <vs-th>Invoice Value</vs-th>
        <vs-th>Invoice Remaining</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <!-- <vs-td :data="indextr + 1">
            {{ indextr + 1 }}
          </vs-td>

          <vs-td :data="getAppliedTo(selected.type)">
            {{ getAppliedTo(selected.type) }}
          </vs-td>

          <vs-td
            :data="
              tr.PurchaseInvoiceID
                ? tr.PurchaseInvoiceCode
                : tr.CreditNoteSupplierCode
            "
          >
            {{
              tr.PurchaseInvoiceID
                ? tr.PurchaseInvoiceCode
                : tr.CreditNoteSupplierCode
            }}
          </vs-td>

          <vs-td
            :data="
              tr.PurchaseInvoiceID
                ? tr.PurchaseInvoiceBeforeValue
                : tr.CreditNoteSupplierBeforeValue
            "
          >
            {{
              tr.PurchaseInvoiceID
                ? priceFormat(tr.PurchaseInvoiceBeforeValue)
                : priceFormat(tr.CreditNoteSupplierBeforeValue)
            }}
          </vs-td>

          <vs-td :data="tr.DebitNoteCode">
            {{ tr.DebitNoteCode }}
          </vs-td>

          <vs-td :data="tr.DebitNoteBeforeValue">
            {{ priceFormat(tr.DebitNoteBeforeValue) }}
          </vs-td>

          <vs-td :data="tr.ClearingValue">
            {{ priceFormat(tr.ClearingValue) }}
          </vs-td>

          <vs-td
            :data="
              tr.PurchaseInvoiceID
                ? tr.PurchaseInvoiceAfterValue
                : tr.CreditNoteSupplierAfterValue
            "
          >
            {{
              tr.PurchaseInvoiceID
                ? priceFormat(tr.PurchaseInvoiceAfterValue)
                : priceFormat(tr.CreditNoteSupplierAfterValue)
            }}
          </vs-td>

          <vs-td :data="tr.DebitNoteAfterValue">
            {{ priceFormat(tr.DebitNoteAfterValue) }}
          </vs-td> -->
          <vs-td :data="indextr + 1">
            {{ indextr + 1 }}
          </vs-td>
          <vs-td :data="tr.debit_note_code">
            {{ tr.debit_note_code }}
          </vs-td>
          <vs-td :data="priceFormat(tr.total_paid)">
            {{ priceFormat(tr.total_paid) }}
          </vs-td>
          <vs-td
            :data="
              tr.purchase_invoice_id
                ? tr.purchase_invoice_code
                : tr.credit_note_supplier_code
            "
          >
            {{
              tr.purchase_invoice_id
                ? tr.purchase_invoice_code
                : tr.credit_note_supplier_code
            }}
          </vs-td>
          <vs-td>
            {{
              getTotal(
                tr.purchase_invoice_id
                  ? tr.purchase_invoice_id
                  : tr.credit_note_supplier_id
              )
            }}
          </vs-td>
          <vs-td>
            {{
              tr.purchase_invoice_id
                ? priceFormat(tr.purchase_invoice_after_value)
                : priceFormat(tr.credit_note_supplier_after_value)
            }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  created() {},
  data() {
    return {
      search: "",
      schemaLines: [],
      informations: [],
    };
  },
  props: {
    selected: Object,
  },
  methods: {
    handleReversal() {
      // //console.log(this.operatingUnitBank,this.supplierBank)

      const params = {
        id: this.selected.ID,
        purchase_payment_request_id: this.selected.ID,
        status_purchase_request: 5,
        reference_code: this.reference_code,
      };
      this.$vs.loading();
      //console.log(params)
      this.$http
        .post("/api/v1/purchase-payment-request/change-status", params)
        .then((result) => {
          //console.log(result)
          this.$vs.loading.close();
          if (result.code == 200) {
            this.handleClose();
            this.$vs.notify({
              title: "Success",
              text: "",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to update",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
        })
        .catch((e) => {});
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    dateFormat(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/debit-note-clearing/lines/" + this.selected.id)
        .then((result) => {
          this.$vs.loading.close();
          this.schemaLines = result.data.lines;
          this.informations = result.data.info;
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
    getAppliedTo(type) {
      if (type === 0) {
        return "Purchase Invoice";
      } else if (type === 1) {
        return "Credit Note Supplier";
      } else {
        return "Invalid";
      }
    },
    getTotal(id) {
      const total = this.informations.find((x) => x.id === id).total;
      return this.priceFormat(total);
    },
  },
  mounted() {
    this.getData();
  },
  computed: {},
  watch: {
    "selected.id"() {
      this.getData();
    },
  },
};
</script>
<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;
}

.pagination button:hover {
  cursor: pointer;
}
</style>
